import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Membership from '@/pages/home/components/Membership';

export default function MembershipPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Gym Membership at HUB30 | Day Pass, Half & Full Month – Jbeil, Lebanon</title>
        <meta
          name="description"
          content="Join HUB30 gym in Jbeil with flexible membership options — Day Pass ($10), Half Month ($45), or Full Month ($60). Full gym floor access and group classes included."
        />
        <meta
          name="keywords"
          content="gym membership Jbeil, gym membership Lebanon, HUB30 pricing, gym day pass Lebanon, monthly gym membership Byblos"
        />
        <link rel="canonical" href="https://hub30gym.com/membership" />
        <meta property="og:title" content="Gym Membership at HUB30 | Flexible Plans – Jbeil, Lebanon" />
        <meta property="og:description" content="Day Pass ($10), Half Month ($45), Full Month ($60). Full gym floor access and group classes at HUB30 in Jbeil." />
        <meta property="og:url" content="https://hub30gym.com/membership" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <Membership />
      </div>
      <Footer />
    </div>
  );
}
